import { Component, OnInit, HostListener } from '@angular/core';
import { PortalService } from '../../../../../services/portal.service';  // Ensure the correct relative path
import { Router } from '@angular/router';
import { EnrollmentComponent } from '../enrollment/enrollment/enrollment.component';
import { EnrollmentFormService } from '../../../../../services/EnrollmentFormService';
import { environment } from '../../../../../environments/environment';
import { UploadMissingDocumentComponent } from '../../modals/upload-missing-document/upload-missing-document.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit {
  patientAccountId: any;
  patientData: any = {}; // Initialize as an empty object
  submissionStatus: string = '';  // To store submission status
  submission: { status: string } = { status: 'Not Submitted' };
  expiryDate: string = '';  // To store the formatted expiry date
  patientAccountDetails: any;
  drugName: any;
  private readonly storageKey = 'patientAccountId';
  manufacturerID: any;
  programId: any;
  programDisplayName: any;
  programName: any;
  isLoading = true;
  programURL: any;
  EmailID: string;
  enrollmentID: any;
  lastEnrollmentStep: any;

  constructor(
    private portalService: PortalService,
    private router: Router,
    private efs: EnrollmentFormService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.EmailID = localStorage.getItem("email");
    this.getPatientAccountDetail();
    this.getManufacturerProgram();
  }

  setPatientAccountId(id: number): void {
    localStorage.setItem(this.storageKey, id.toString());
  }

  getManufacturerProgram() {
    this.portalService.getManufacturerProgram(environment.programURL).subscribe((data: any) => {
      this.manufacturerID = data.manufacturerID;
      this.programId = data.programId;
      this.programName = data.programName;
      this.programURL = data.programURL;
      localStorage.setItem("manufacturerID", data.manufacturerID);
      localStorage.setItem("programId", data.programId);
      localStorage.setItem("programURL", data.programURL);
    });

  }

  continue() {
    this.isLoading = true;
    this.efs.resetForm();
    const route = this.efs.getRouteFromSequence(this.lastEnrollmentStep);
    localStorage.setItem('CurrentEnrollmentStep', this.lastEnrollmentStep);
    this.portalService.getEnrollmentById(null, this.enrollmentID).subscribe((res) => {
      this.isLoading = false;
      this.efs.patchEnrollmentForm(res);
      this.router.navigate(['/enrollment/' + this.enrollmentID + route.enrollmentRoute]);
    });
  }

  uploadDocument(){
    console.log('Opening dialog with EnrollmentID:', this.enrollmentID); // Debug log

    const dialogRef = this.dialog.open(UploadMissingDocumentComponent, {
      data: { enrollmentId: this.enrollmentID },
      minWidth: '50vw',
      minHeight: '70vh',
      autoFocus: false,
      disableClose: true,
    });


    dialogRef.afterClosed().subscribe((result) => {
      if(result) this.getPatientSubmissionListById();
    });
  }

  getPatientSubmissionListById() {
    this.portalService.getPatientSubmissionsByPatientId(this.patientAccountDetails.patientAccountId).subscribe((data: any) => {
      this.isLoading = false;
      console.log(data);
      if (data) {
        this.patientData = data.patientSubmissions[0];
        this.submissionStatus = this.patientData.status;
        this.drugName = data.patientSubmissions[0].drugName;
        this.expiryDate = this.formatDate(this.patientData.expiryDate);
        this.enrollmentID = data.patientSubmissions[0].enrollmentId;
        this.lastEnrollmentStep = data.patientSubmissions[0].lastEnrollmentStep;
      }
    });
  }

  getPatientAccountDetail() {
    this.portalService.getPatientAccountDetail(this.EmailID).subscribe((data: any) => {
      if (data) {
        this.patientAccountDetails = data;
        this.patientAccountId = data.patientAccountId;
        localStorage.setItem('patientAccountId',this.patientAccountId);
        this.setPatientAccountId(data.patientAccountId);
        this.getPatientSubmissionListById();
      }
    });
  }
 
  formatDate(date: string): string {
    if (!date || date === '0001-01-01T00:00:00') {
      return 'N/A'; 
    }
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString('en-US'); 
  }

  viewAllSubmissions() {
    this.router.navigate(['/submissions'])
  }
  
}
